var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React from 'react';
import ReactDOM from 'react-dom';
import styles from './index.css';
import { postJub } from '../../utils/api';
const { cookie } = require('@ifeng/ui_base');
const jubaoList = ['色情淫秽', '骚扰谩骂', '广告欺诈', '反动', '其他'];
class JubDialog extends React.PureComponent {
    constructor() {
        super(...arguments);
        this.state = {
            selectedIndex: 0,
            content: '请描述恶意行为',
            jubSuc: false,
        };
        this.handleCloseJub = () => {
            const { handleJubShow } = this.props;
            handleJubShow();
            cookie.set('jubTime', 0);
        };
        // 提交举报信息
        this.handleSubmitJub = () => __awaiter(this, void 0, void 0, function* () {
            try {
                const { selectedIndex, content } = this.state;
                const { jubCommentId, jubUrl } = this.props;
                const data = yield postJub(jubUrl, jubCommentId, jubaoList[selectedIndex], content);
                // 举报成功
                if (data.code === 1) {
                    this.initJubInfo();
                    const jubCommentIdArr = cookie.get('jubCommentIdArr') ? cookie.get('jubCommentIdArr').split(',') : [];
                    if (!jubCommentIdArr.includes(jubCommentId)) {
                        jubCommentIdArr.push(jubCommentId);
                    }
                    cookie.set('jubCommentIdArr', jubCommentIdArr.join(','));
                    this.setState({
                        jubSuc: true,
                    });
                }
                else if (data.code === 119) {
                    this.initJubInfo();
                    window.alert('您举报的过于频繁，请稍作休息。');
                }
                else {
                    this.initJubInfo();
                    window.alert('举报失败，请您稍后再试。');
                }
            }
            catch (e) {
                console.error(e);
            }
        });
        // 举报信息初始化
        this.initJubInfo = () => {
            this.setState({
                selectedIndex: 0,
                content: '请描述恶意行为',
            });
        };
        // 修改其他原因
        this.handleChangetText = (e) => {
            if (e.currentTarget) {
                const content = e.currentTarget.value;
                this.setState({
                    content,
                });
            }
        };
        // 获得选取的举报原因选项
        this.handleSelectReason = (index) => {
            this.setState({
                selectedIndex: index,
            });
        };
    }
    render() {
        const { selectedIndex, jubSuc } = this.state;
        return ReactDOM.createPortal(React.createElement(React.Fragment, null,
            React.createElement("div", { className: styles.zhezhao }),
            React.createElement("div", { className: styles.jubao },
                React.createElement("div", { className: styles.jbClose, onClick: this.handleCloseJub }),
                React.createElement("div", { className: styles.jbTit },
                    React.createElement("div", { className: styles.logo }),
                    React.createElement("div", { className: styles.tt }, "\u4E3E\u62A5")),
                jubSuc ? (React.createElement("div", { className: styles.jbSuc },
                    React.createElement("p", null,
                        React.createElement("span", null, "\u00A0"),
                        "\u4E3E\u62A5\u6210\u529F\uFF0C\u6211\u4EEC\u4F1A\u5C3D\u5FEB\u5904\u7406\u60A8\u7684\u4E3E\u62A5\u4FE1\u606F\uFF0C\u8BF7\u8010\u5FC3\u7B49\u5F85\u3002"),
                    React.createElement("div", { className: styles.btn, onClick: this.handleCloseJub }, "\u6211\u77E5\u9053\u4E86"))) : (React.createElement("div", { className: styles.jbTxt },
                    React.createElement("div", { className: styles.jbBox },
                        React.createElement("div", { className: styles.tit }, "\u60A8\u4E3A\u4EC0\u4E48\u8981\u4E3E\u62A5\u6B64\u4FE1\u606F\uFF1F"),
                        React.createElement("ul", { className: styles.jbList }, jubaoList.map((item, index) => {
                            return (React.createElement("li", { key: index, className: `${selectedIndex === index ? styles.selected : ''} clearfix`, "data-index": index, onClick: () => this.handleSelectReason(index) },
                                React.createElement("p", null,
                                    React.createElement("input", { type: "radio" })),
                                React.createElement("span", null, item)));
                        }))),
                    React.createElement("div", { className: styles.jbBox },
                        React.createElement("div", { className: styles.tit }, "\u5177\u4F53\u63CF\u8FF0\uFF08\u9009\u586B\uFF09\uFF1A"),
                        React.createElement("div", { className: styles.jbText },
                            React.createElement("input", { id: "texts", placeholder: "\u8BF7\u63CF\u8FF0\u6076\u610F\u884C\u4E3A", onChange: this.handleChangetText }))),
                    React.createElement("div", { className: styles.jbBtn },
                        React.createElement("a", { href: "javascript:void(0)", onClick: this.handleSubmitJub, className: styles.submit }, "\u63D0\u4EA4"),
                        React.createElement("a", { href: "javascript:void(0)", onClick: this.handleCloseJub, className: styles.cancel }, "\u53D6\u6D88")))))), document.body);
    }
}
export default JubDialog;
